import React from 'react'

import {withTranslation} from 'react-i18next'
import {connect} from 'react-redux'
import Moment from 'moment'

import {history} from "../../../store"
import employeeService from '../../../services/Employee.service'
import {UserRoles} from "../../../constants"
import {NavigationTo} from "../common"
import { COMPONENT_IDS } from '../../../components/v2/common/common'

import {Col, Flex} from '@amzn/stencil-react-components/layout'
import {Text} from '@amzn/stencil-react-components/text'
import {Card} from '@amzn/stencil-react-components/card'
import {Button, ButtonSize, ButtonVariant} from '@amzn/stencil-react-components/button'
import {WithBreakpoints} from '@amzn/stencil-react-components/responsive'

class SubHeader extends React.Component {

  constructor(props) {
    super(props);
  }

  hasAwards = (employee) => {
    return employee.awards.length > 0;
  }

  onAvailableBrokerButtonClick = () => {
    history.push({pathname: NavigationTo.AvailableBrokers, state: {buttonNav: true}});
    // Only works if already on the Available Broker tab
    document.getElementById(COMPONENT_IDS.FirstBrokerCard)?.focus();
  }

  onBrokerAccountButtonClick = (employee) => {
    const targetUrl = employeeService.getEmployeeBrokerUrl(employee);
    window.open(targetUrl);
  }

  getCurrentBroker = (employee, t) => {
    if (employee.broker) {
      return <Text fontSize="T300" fontWeight="bold">{employee.broker.name}</Text>;
    }
  }

  getW8W9message = (employee) => {
    if (!employeeService.isBrokerChoiceNone(employee)) {
      return <Text dataTestId="W8W9Message-Text">{employee.w8_w9_message}</Text>;
    }
  }

  getNextVestInfo = (employee, t) => {
    const nextVest = employee.summary.next_vest;
    const locale = employee.language;
    const vestQuantity = new Intl.NumberFormat(locale).format(nextVest ? nextVest.shares_vest : 0);

    if (this.hasAwards(employee) && nextVest) {
      return (
        <Text dataTestId="NextVestInfo-Text">
          {t('Header.NextVestInfo', {
            vest_quantity: vestQuantity,
            vest_date: Moment(nextVest.next_vest_date).format('ll')
          })}
        </Text>
      );
    }
  }

  getBrokerInfoButtons = (employee, t) => {
    return (
      <WithBreakpoints>
        {({matches}) => (
          <Flex
            margin={matches.s ? {top:20} : {}}
            gridGap="S200"
            alignItems={matches.s ? "end" : "center"}
            flexDirection={matches.s ? "column" : "row"}
          >
            {!employeeService.hasRole(employee.roles, UserRoles.BROKER_CHOICE_NONE) && employeeService.showAvailableBrokers(employee) &&
              <Button 
                dataTestId='AvailableBroker-Button'
                onClick={this.onAvailableBrokerButtonClick}
                size={ButtonSize.Small}>
                  {t(`Header.AvailableBrokersLink`)}
              </Button>
            }
            {employee.broker &&
              <Button
                dataTestId='BrokerAccount-Button'
                onClick={() => this.onBrokerAccountButtonClick(employee)}
                variant={ButtonVariant.Primary}
                size={ButtonSize.Small}>
                  {t(`Header.GoToBrokerLink`, {broker_name: employee.broker && employee.broker.name})}
              </Button>
            }
          </Flex>
        )}
      </WithBreakpoints>
    );
  }

  render() {
    const {employee, t} = this.props;
    return (
      <WithBreakpoints>
        {({matches}) => (
          <Card dataTestId="SubHeader-Card">
            <Flex width="100%" flexDirection={matches.s ? "column" : "row"}>
              <Col gridGap="S200" width="100%">
                {this.getCurrentBroker(employee, t)}
                <Col>
                  {this.getW8W9message(employee)}
                  {this.getNextVestInfo(employee, t)}
                </Col>
              </Col>
              {this.getBrokerInfoButtons(employee, t)}
            </Flex>
          </Card>
        )}
      </WithBreakpoints>
    );
  }
}

const mapState = state => ({
  employee: state.employee
})

export default connect(mapState)(withTranslation('translationsV2')(SubHeader))
